import { Deserializable } from '../protocols/deserializable';
import { MemberFundingBlockingSubmission } from './member-funding-submission-in-progress';

export class RetirementProductSubmissionAvailability implements Deserializable {
  public canStart!: boolean;
  public reason!: string | null;
  public blockingSubmission!: MemberFundingBlockingSubmission | null;

  public onDeserialize(): void {
    this.blockingSubmission = this.blockingSubmission
      ? window?.injector?.Deserialize?.instanceOf(MemberFundingBlockingSubmission, this.blockingSubmission)
      : null;
  }
}
